import React from "react";

const PALETTE = { W: "#E8F4FF", Y: "#4FA8E0", O: "#1B5FAF", R: "#0E3A75" };

const _ = null;
const W = "W";
const Y = "Y";
const O = "O";
const R = "R";

const GRID = [
  [_, _, _, _, Y, _, _, _, _, _, _],
  [_, _, _, _, Y, Y, _, _, _, _, _],
  [_, _, _, Y, Y, Y, _, _, _, _, _],
  [_, _, _, Y, W, Y, Y, _, _, _, _],
  [_, _, Y, W, W, Y, Y, _, _, _, _],
  [_, _, Y, W, W, W, Y, _, _, _, _],
  [_, Y, Y, W, W, W, W, Y, _, _, _],
  [_, Y, W, W, W, W, W, Y, _, _, _],
  [Y, Y, W, W, W, W, W, Y, O, _, _],
  [Y, W, W, W, W, W, Y, Y, O, R, _],
  [Y, O, W, W, W, W, Y, O, R, R, _],
  [Y, O, O, Y, Y, Y, O, O, R, _, _],
  [_, O, O, O, O, O, O, R, R, _, _],
  [_, _, _, R, R, R, R, _, _, _, _],
];

const COLS = 11;
const ROWS = 14;

export default function PixelFire({ size = 36 }) {
  const rects = [];
  for (let y = 0; y < ROWS; y++) {
    for (let x = 0; x < COLS; x++) {
      const key = GRID[y][x];
      if (key) {
        rects.push(
          <rect key={`${x}-${y}`} x={x} y={y} width={1.02} height={1.02} fill={PALETTE[key]} />
        );
      }
    }
  }

  return (
    <svg width={size} height={size} viewBox={`0 0 ${COLS} ${ROWS}`} aria-hidden="true">
      {rects}
    </svg>
  );
}
